import { CircularProgress } from "@mui/material";
import { useStopwatch, useTimer } from "react-timer-hook";
import Styles from "./TestComponentStyles.module.css";
import { useEffect } from "react";
import { useTestStore } from "../../hooks/store";
import { testStatus, testType } from "../../utils/testHelper";
import AccessTimeRoundedIcon from "@mui/icons-material/AccessTimeRounded";
import { canceleTest } from "../../utils/API/biletMethod";
export function TestTimer() {
  const testStore = useTestStore();
  const expiryTimestamp = new Date();

  expiryTimestamp.setSeconds(
    expiryTimestamp.getSeconds() +
      (1200 - (Math.floor(new Date().getTime() / 1000) - testStore.startTime)),
  );

  const {
    totalSeconds,
    milliseconds,
    seconds,
    minutes,
    hours,
    days,
    isRunning,
    start,
    pause,
    resume,
    restart,
  } = useTimer({
    expiryTimestamp,
    onExpire: () => testStore.canceleTest(),
    autoStart: false,
    interval: 1000,
  });

  const stopWatch = useStopwatch({ autoStart: false, interval: 1000 });

  useEffect(() => {
    testStore.testType == testType.bilet ||
    testType.exam.type === testStore.testType.type
      ? start()
      : stopWatch.start();
  }, []);

  useEffect(() => {
    testStore.testStatus === testStatus.finish && pause();
  }, [testStore.testStatus]);

  const normalizeTimeToprogres = (value) => {
    const minValue = 0;
    const maxValue = 1200;
    return Math.floor(((value - minValue) * 100) / (maxValue - minValue));
  };

  return (
    <div className={Styles.test_timer}>
      <p>
        {testStore.testType == testType.bilet ||
        testStore.testType.type == testType.exam.type
          ? `${(minutes.toString().length == 1 && `0${minutes}`) || minutes}:${
              (seconds.toString().length == 1 && `0${seconds}`) || seconds
            }
          `
          : `${
              (stopWatch.minutes.toString().length == 1 &&
                `0${stopWatch.minutes}`) ||
              stopWatch.minutes
            }:${
              (stopWatch.seconds.toString().length == 1 &&
                `0${stopWatch.seconds}`) ||
              stopWatch.seconds
            }
            `}
      </p>
      {testStore.testType.type == testType.bilet.type ||
      testStore.testType.type == testType.exam.type ? (
        <CircularProgress
          style={{ height: "25px", width: "25px" }}
          variant="determinate"
          className="time-progress"
          value={normalizeTimeToprogres(totalSeconds)}
        />
      ) : (
        <AccessTimeRoundedIcon style={{ height: "20px", width: "20px" }} />
      )}
    </div>
  );
}
